import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("mappingReducer");
log.setLevel("debug");

const initialState = {
	hasRelatedContacts: false,
	contactRoleCategory: [],
	contactRoleSegment: [],
	contactRole: [],
	lastUpdated: new Date()
};

function mappingReducer(state = initialState, action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset mapping state");
			return initialState;
		}
		case actionTypes.SET_HAS_RELATED_CONTACTS: {
			return {
				...state,
				hasRelatedContacts: action.payload,
				lastUpdated: new Date()
			};
		}
		case actionTypes.SET_CONTACT_ROLE_CATEGORY: {
			return {
				...state,
				contactRoleCategory: action.payload,
				lastUpdated: new Date()
			};
		}
		case actionTypes.SET_CONTACT_ROLE_SEGMENT: {
			return {
				...state,
				contactRoleSegment: action.payload,
				lastUpdated: new Date()
			};
		}
		case actionTypes.SET_CONTACT_ROLE: {
			return {
				...state,
				contactRole: action.payload,
				lastUpdated: new Date()
			};
		}
		case actionTypes.RESET_RELATED_CONTACTS: {
			return {
				...state,
				hasRelatedContacts: false,
				contactRoleCategory: [],
				contactRoleSegment: [],
				contactRole: [],
				lastUpdated: new Date()
			};
		}
		default:
			return state;
	}
}

export default mappingReducer;
